export enum FileVolatilityStatus {
    IN_PROGRESS = "In progress",
    SUCCESS = "Success",
    FAILURE = "Failure"
}